module.exports = __webpack_public_path__ + "static/media/mc.c9eb28fb.svg";